import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Collapse,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import MarkdownRenderer from "./MarkdownRenderer";

import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";

interface MessageContentProps {
  sender: "user" | "bot";
  content: string;
  theme?: any;
}

const MessageContent: React.FC<MessageContentProps> = ({
  sender,
  content,
}) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(false);
  }, [content]);

  if (sender === "bot") {
    const toolMatch = content
      .trim()
      .match(
        /กำลังเริ่มการทำงานของเครื่องมือ:\s*(.*?)\s*ข้อมูลที่ส่งไป:\s*({[\s\S]*})/
      );

    if (toolMatch) {
      const [_, toolName, queryData] = toolMatch;
      
      const glassContainerSx = {
        background: theme.palette.mode === 'dark' 
            ? 'rgba(0, 0, 0, 0.25)' 
            : 'rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(8px)',
        border: `1px solid rgba(255, 255, 255, 0.1)`,
        borderRadius: '16px',
        overflow: 'hidden',
      };

      return (
        <Box sx={glassContainerSx}>
          <Box
            sx={{
              p: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              '&:hover': {
                backgroundColor: alpha(theme.palette.common.white, 0.05)
              }
            }}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <HandymanOutlinedIcon
                sx={{ fontSize: 18, color: "primary.main" }}
              />
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                กำลังใช้เครื่องมือ:{" "}
                <span style={{ fontWeight: 600 }}>{toolName}</span>
              </Typography>
            </Box>
            <IconButton size="small" edge="end">
              {isExpanded ? (
                <ExpandLessOutlinedIcon sx={{ fontSize: 20 }} />
              ) : (
                <ExpandMoreOutlinedIcon sx={{ fontSize: 20 }} />
              )}
            </IconButton>
          </Box>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box sx={{ p: 2, borderTop: "1px solid", borderColor: "divider", background: alpha(theme.palette.common.black, 0.1) }}>
                <MarkdownRenderer content={"```json\n" + queryData + "\n```"} />
            </Box>
          </Collapse>
        </Box>
      );
    }

    return (
      <Typography variant="body1" component="div">
        <MarkdownRenderer content={content} />
      </Typography>
    );
  }

  return <Typography variant="body1">{content}</Typography>;
};

export default MessageContent;